import { Map, List, fromJS } from 'immutable'
import { getElementDataRoot } from '../../constants/getElementDataRoot'
import { getValueForMode } from '../../constants/toUnits'
import { getAxios } from '../../lib/projectAxios'
import * as actionTypes from './actionTypes'
import { ftCloseModal } from './ftCloseModal'
import { processSlackMessage } from './processSlackMessage'
import { processSfLWCRedirect } from './processSfLWCRedirect'
import { collectAutoPDFState, processDocGen, processDocGenTitanSign } from './processDocGen'
import { processAIAction } from './processAIAction'
import { processButtonAction } from './processButtonAction'
import { processWidgetSFMapping } from './processWidgetSFMapping'
import { getPageUID } from '../../lib/getValueByType'
import _ from 'lodash'
import { getElementFromPath, getState, toPlainValue, updateOldValue } from '../../lib/processPortalRules'
import { getFormDateFormat } from '../../lib/format'
import moment from 'moment'
import { processSubmissionFlowNode } from './processSubmissionFlow'
import { LayoutNames } from '../../constants/LayoutNames'

const axios = getAxios()

export const processWorkFlow = async (
  actionID,
  params,
  dispatch,
  getAppState,
  testMode,
  paramsRequested,
  runInBackGround = true,
  entry
) => {
  let state = getAppState()
  const pageID = state.get('page')
  let pageUID = getPageUID(pageID, state.getIn(['project', 'Pages']))
  let currentPageUID = state
    .getIn(['project', 'Pages'], List())
    .find((page) => page.get('_id') === pageID)
    ?.get?.('uid')

  let pageFields = state.getIn(['state', pageUID], Map()).toJS()
  const layout = state.get('layoutMode', 'lg')
  pageFields['device'] = LayoutNames[layout]
  let requestData = {
    actionID: actionID,
    params: state.getIn(['params'], Map()).toJS(),
    page: pageFields,
    isPreview: testMode,
    actionParams: params,
  }
  let formData = new FormData()
  if (Map.isMap(entry.getIn(['payload', 'options']))) {
    entry.getIn(['payload', 'options']).map((value, key) => {
      if (['ftDocGenEditDocx', 'ftDocGenEditPdf'].includes(key)) {
        formData.append(value, _.get(window, ['__FT_PROJECT__API__FILES__', key, value]))
      } else {
        formData.append(key, JSON.stringify(value))
      }
    })
  }
  _.each(requestData, (value, key) => {
    if (value) {
      formData.append(key, _.isObject(value) ? JSON.stringify(value) : value)
    }
  })
  const docGenList = []
  if (currentPageUID) {
    const RepeatedStripsID = state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
    const fileKeys = {}
    const hashSubmissions = {}
    _.each(paramsRequested, (value, key) => {
      if (_.startsWith(value.field, 'ftWebSubmission##') && value.webSubmission) {
        let customNode = {
          data: {
            Submissions: [value.webSubmission],
          },
        }
        hashSubmissions[key] = customNode
        return
      }
      if (_.endsWith(value.field, 'docGen')) {
        if (!fileKeys[key]) {
          fileKeys[key] = []
        }
        fileKeys[key].push(value.field)
        docGenList.push(String(value.field).split('##-##')[0])
        return
      }
      if (value?.valueType === 'field') {
        const fieldKey = _.first(String(value.field).split('##-##'))
        const fieldPath = String(fieldKey).split(':')
        const parentElement = fieldPath[0] === currentPageUID ? pageID : 'project'
        const isElementVisible = state.getIn(['state', 'project', fieldPath[0]]) === false
        const elementDataRoot = getElementDataRoot(parentElement)
        if (String(fieldKey).indexOf('-fileWithMark') > -1) {
          let [pageUID, uid, ...restUIDPath] = String(fieldKey).split(':')
          let fileVal = _.get(window, [
            '__FT_PROJECT__API__FILES__',
            'files',
            String(uid).replace('-fileWithMark', ''),
            'fileWithMark',
            0,
          ])
          if (fileVal) {
            formData.append(key, fileVal, 'interactive_image_markers.png')
          }
        } else if (String(fieldKey).indexOf('-file') > -1) {
          let [pageUID, uid, ...restUIDPath] = String(fieldKey).split(':')
          let fileVal = _.get(window, [
            '__FT_PROJECT__API__FILES__',
            'files',
            String(uid).replace('-file', ''),
            'file',
            0,
          ])
          if (fileVal) {
            formData.append(key, fileVal, 'interactive_image.png')
          }
        } else if (
          String(fieldKey).includes(':ft_fileupload_docx') ||
          String(fieldKey).includes(':ft_fileupload_sfdt') ||
          String(fieldKey).includes(':ft_fileupload_pdf')
        ) {
          let keyFile = 'ftDocGenEditDocx'
          let uid = fieldPath[fieldPath.length - 2]
          let format = 'docx'
          if (String(fieldKey).includes(':ft_fileupload_sfdt')) {
            keyFile = 'ftDocGenEditSfdt'
            format = 'sfdt'
          }
          let fileVal = _.get(window, ['__FT_PROJECT__API__FILES__', keyFile, uid])
          if (fileVal) {
            formData.append(key, fileVal, 'Document.' + format)
          }
        } else if (fieldPath[0] === currentPageUID || isElementVisible) {
          let elemID = null
          if (RepeatedStripsID.includes(fieldPath[1])) {
            elemID = fieldPath[2]
          } else {
            elemID = fieldPath[1]
          }
          if (elemID) {
            const elem = state.getIn([...elementDataRoot, 'elements', elemID], Map())
            if (elem.get('type') === 'FormField' && elem.getIn(['props', 'control']) === 'fileupload') {
              const files = _.get(window, ['__FT_PROJECT__API__FILES__', 'files', elemID], {})
              if (files) {
                if (RepeatedStripsID.includes(fieldPath[1])) {
                  _.each(files, (section, index) => {
                    if (section && section.files) {
                      if (!fileKeys[key]) {
                        fileKeys[key] = []
                      }
                      fileKeys[key].push(key + '___' + index)
                      _.each(section.files, function (file) {
                        formData.append(key + '___' + index, file)
                      })
                    }
                  })
                } else {
                  if (!fileKeys[key]) {
                    fileKeys[key] = []
                  }
                  fileKeys[key].push(key)
                  _.each(files.files, (file) => {
                    formData.append(key, file)
                  })
                }
              }
            } else if (elem.get('type') === 'Capture') {
              const files = _.get(window, ['__FT_PROJECT__API__FILES__', 'files', elemID], {})
              if (files) {
                if (RepeatedStripsID.includes(fieldPath[1])) {
                  _.each(files, (section, index) => {
                    if (section && section.files) {
                      if (!fileKeys[key]) {
                        fileKeys[key] = []
                      }
                      fileKeys[key].push(key + '___' + index)
                      _.each(section.files, function (file) {
                        formData.append(key + '___' + index, file)
                      })
                    }
                  })
                } else {
                  if (!fileKeys[key]) {
                    fileKeys[key] = []
                  }
                  fileKeys[key].push(key)
                  _.each(files.files, (file) => {
                    formData.append(key, file)
                  })
                }
              }
            }
          }
        }
      }
    })
    if (_.size(hashSubmissions)) {
      let list = []
      let submissionData = {}
      let submissionFileKeys = {}
      _.each(hashSubmissions, (node, key) => {
        list.push(
          new Promise(async (resolve) => {
            let data = await processSubmissionFlowNode(node, getAppState, dispatch, true)
            if (data.status) {
              submissionData[key] = _.get(data, ['data', 'data'])
              if (data.files) {
                _.each(data.files, (fileList, fileKey) => {
                  submissionFileKeys[fileKey] = _.get(data, ['data', 'data', fileKey])
                  if (fileList) {
                    _.each(fileList, (file, fileIndex) => {
                      if (file) {
                        formData.append(fileKey + '___' + fileIndex, file)
                      }
                    })
                  }
                })
              }
            }
            resolve()
          })
        )
      })

      await Promise.all(list)
      formData.append('submissionFileKeys', JSON.stringify(submissionFileKeys))
      formData.append('submissionData', JSON.stringify(submissionData))
    }

    formData.append('fileKeys', JSON.stringify(fileKeys))
  }
  if (docGenList) {
    let autoPDfState
    let wordState
    _.each(docGenList, (genID) => {
      const type = state.getIn(['project', 'Settings', 'store', 'public', genID, 'type'])
      if (type === 'AUTO_PDF') {
        if (!autoPDfState) {
          autoPDfState = collectAutoPDFState(state)
        }
      } else if (type === 'DOCGEN') {
        if (!wordState) {
          const currState = getState(state)
          wordState = state
            .getIn(['project', 'Settings', 'store', 'public', genID, 'templateFields'], List())
            .reduce((r, v) => {
              const group = v.get('group')
              if (group === 'param') {
                return r.set(v.get('value'), state.getIn(['params', String(v.get('value')).replace('param', '')], ''))
              } else if (group === 'pageParam') {
                const [pageUID, paramID] = String(v.get('value')).split(':')
                return r.set(v.get('value'), state.getIn(['state', pageUID, paramID], ''))
              } else {
                const value = String(v.get('value'))
                if (_.startsWith(group, 'formWidget:') || _.startsWith(group, 'listWidget:')) {
                  return r.set(value, toPlainValue(_.get(currState, value.replace(/:/g, '.'), '')))
                } else if (_.startsWith(group, 'form:')) {
                  return r.set(
                    value,
                    toPlainValue(_.get(currState, `${_.get(window.__FT_APP_STATE__, 'widget._id')}.${value}`, null))
                  )
                } else if (group === 'smartv') {
                  return r.set(value, isUserSignIn ? 'true' : '')
                } else {
                  let path = updateOldValue(value).split(':')
                  let elem = getElementFromPath(path, state)
                  if (elem.get('type') === 'Widget' && elem.getIn(['props', 'data', 'Type']) === 'ImageChoice') {
                    if (_.last(path) === 'ftListLabel') {
                      return r.set(value, toPlainValue(_.get(currState, [..._.initial(path), 'ftListValue'], '')))
                    }
                    return r.set(value, toPlainValue(_.get(currState, [...path, 'ftListValue'], '')))
                  } else if (elem.get('type') === 'FormField' && ['time'].includes(elem.getIn(['props', 'control']))) {
                    let val = toPlainValue(_.get(currState, updateOldValue(value).replace(/:/g, '.'), ''))
                    let format = getFormDateFormat(
                      elem.getIn(['props', state.get('layoutMode', 'lg')], Map()).toJS(),
                      elem.getIn(['props', 'control'])
                    )
                    let date = moment(val)
                    if (date.format() !== 'Invalid date') {
                      return r.set(value, date.format(format))
                    } else {
                      date = moment(moment().format('YYYY-MM-DD') + 'T' + val)
                      if (date.format() !== 'Invalid date') {
                        return r.set(value, date.format(format))
                      }
                    }
                    return r.set(value, val)
                  } else if (
                    elem.get('type') === 'FormField' &&
                    ['time', 'date', 'datetime'].includes(elem.getIn(['props', 'control']))
                  ) {
                    let val = toPlainValue(_.get(currState, updateOldValue(value).replace(/:/g, '.'), ''))
                    let format = getFormDateFormat(
                      elem.getIn(['props', state.get('layoutMode', 'lg')], Map()).toJS(),
                      elem.getIn(['props', 'control'])
                    )
                    let date = moment(val)
                    if (date.format() !== 'Invalid date') {
                      return r.set(value, date.format(format))
                    } else {
                      return r.set(value, toPlainValue(_.get(currState, updateOldValue(value).replace(/:/g, '.'), '')))
                    }
                  }
                  return r.set(value, toPlainValue(_.get(currState, updateOldValue(value).replace(/:/g, '.'), '')))
                }
              }
            }, Map())
            .toJS()
        }
      }
    })
    if (autoPDfState) {
      formData.append('autoPDfState', JSON.stringify(autoPDfState))
    }
    if (wordState) {
      formData.append('wordState', JSON.stringify(wordState))
    }
  }
  if (!runInBackGround) {
    dispatch({
      type: actionTypes.SHOW_LOADING_WINDOW,
      payload: {
        messages: _.compact([entry?.getIn?.(['payload', 'modalMsg'], '')]),
      },
    })
  }

  const recursiveProcessGet = async (attemp) => {
    const statusesToIgnoreAsError = [502, 504]

    if (attemp >= 3) {
      return {
        status: 200,
        data: {
          status: false,
        },
      }
    }
    const requestStartTime = new Date()
    try {
      let result = await axios.post('/webprojects/workflow/process', formData, {
        'Content-Type': 'multipart/form-data',
      })
      return result
    } catch (err) {
      console.log('err >>> ', err)
      const requestDurationInMS = new Date() - requestStartTime
      const minuteInMS = 60 * 1000
      if (requestDurationInMS >= minuteInMS && statusesToIgnoreAsError.includes(err.response?.status)) {
        return {
          status: 200,
          data: {
            status: true,
          },
        }
      }

      await new Promise((resolve) => {
        setTimeout(resolve, 2 * 1000)
      })

      return recursiveProcessGet(attemp + 1)
    }
  }

  let { status, data } = await recursiveProcessGet(0)

  if (!runInBackGround) {
    dispatch({
      type: actionTypes.CLOSE_LOADING_WINDOW,
    })
  }
  let result = {}
  if (!data.status) {
    result = {
      status: false,
    }
  } else {
    result = {
      status: true,
    }
  }
  if (entry && entry.getIn(['payload', 'flow', 'currentNode'])) {
    let processNodes = List()
    entry.getIn(['payload', 'flow', 'list'], List()).map((node) => {
      if (result.status) {
        if (
          node.get('source') == entry.getIn(['payload', 'flow', 'currentNode']) &&
          node.get('sourceHandle') !== 'invalid'
        ) {
          entry.getIn(['payload', 'flow', 'list'], List()).map((subNode) => {
            if (subNode.get('id') == node.get('target')) {
              processNodes = processNodes.push(subNode)
            }
          })
        }
      } else {
        if (
          node.get('source') == entry.getIn(['payload', 'flow', 'currentNode']) &&
          node.get('sourceHandle') === 'invalid'
        ) {
          entry.getIn(['payload', 'flow', 'list'], List()).map((subNode) => {
            if (subNode.get('id') == node.get('target')) {
              processNodes = processNodes.push(subNode)
            }
          })
        }
      }
    })

    let state = getAppState()
    processNodes.map((node) => {
      state = state.setIn(
        ['__cache__'],
        state.getIn(['__cache__'], List()).push(
          fromJS({
            type: 'FlowActionStep',
            payload: {
              list: entry.getIn(['payload', 'flow', 'list'], List()).toJS(),
              current: node.get('id'),
              index: entry.getIn(['payload', 'flow', 'index']),
              currentRule: Map(),
              currentSingleRule: Map(),
              isOnlyEffects: entry.getIn(['payload', 'flow', 'isOnlyEffects']),
            },
          })
        )
      )
    })
    dispatch({
      type: actionTypes.SET_STORE,
      payload: {
        store: state,
      },
    })
  }

  if (entry && entry.getIn(['payload', 'returnParams']) && data && data.status) {
    let updateParams = {}
    entry.getIn(['payload', 'returnParams'], Map()).map((row, key) => {
      if (row && row.get('valueType') == 'field') {
        if (data && data.data && data.data[row.get('field')] !== undefined) {
          updateParams[key] = data.data[row.get('field')]
        }
      } else if (row && row.get('value')) {
        updateParams[key] = row.get('value')
      }
    })

    dispatch({
      type: actionTypes.WB_SET_PARAMS_TO_STATE,
      payload: {
        params: updateParams,
      },
    })
  }

  return result
}
